// LoginSignUpButton.jsx
import React, { useCallback } from 'react';

import PropTypes from 'prop-types';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import ResetButtonStyle from '../style/ResetButtonStyle.js';
import { color } from '../style/variables.js';
import trackMixpanel, {
  EventTypes,
  ButtonId,
  getViewId,
} from '../resource/mixpanel.js';

export const LoginSignUpButton = ({ login }) => {
  const { t } = useTranslation();
  const trackUserClick = useCallback(({ buttonId }) => {
    trackMixpanel({
      type: EventTypes.USER_CLICKED,
      payload: {
        viewId: getViewId({ pathname: window.location.pathname }),
        buttonId,
      },
    });
  }, []);

  return (
    <>
      <LoginButton
        data-element_id={ButtonId.LoginRegister.ButtonLogin}
        onClick={() => {
          trackUserClick({
            buttonId: ButtonId.LoginRegister.ButtonLogin,
          });
          return login({ entry: 'login' });
        }}
      >
        <LoginButtonText>{t('login')}</LoginButtonText>
      </LoginButton>
      <SignupButton
        data-element_id={ButtonId.LoginRegister.ButtonSignup}
        onClick={() => {
          trackUserClick({
            buttonId: ButtonId.LoginRegister.ButtonSignup,
          });
          return login({ entry: 'register' });
        }}
      >
        <LoginButtonText>{t('sign_up')}</LoginButtonText>
      </SignupButton>
    </>
  );
};

LoginSignUpButton.propTypes = {
  login: PropTypes.func,
};

LoginSignUpButton.defaultProps = {
  login: () => null,
};

// const StyledLoginSignUpButton = styled.div``;

const AuthButton = styled.button`
  ${ResetButtonStyle};
  margin-left: 8px;
  flex: none;
  display: flex;
  align-items: center;
  height: 32px;
  padding: 0 12px;
  font-size: 16px;
  border-radius: 4px;
  transition: opacity 0.4s;
  opacity: 1;
  @media (hover: hover) {
    :hover {
      opacity: 0.8;
    }
  }
`;

const LoginButton = styled(AuthButton)`
  color: ${color.white};
  border: solid 1px #474747;
`;

const SignupButton = styled(AuthButton)`
  color: ${color.black};
  background-color: ${color.tealBlue};
`;

const LoginButtonText = styled.div``;

export default LoginSignUpButton;
